export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/roblox.9efa7fd.svg";